import { lazy, Suspense } from 'react';
import { CircularProgress } from '@mui/material';

import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import RoutePrivate from 'components/common/route-private';
import { config } from 'config';

const AdminRoles = lazy(() => import('components/ETC/adminRoles'))
const AdminActionLogs = lazy(() => import('components/ETC/adminActionLogs'))
const TesterAccount = lazy(() => import('components/ETC/testerAccounts'))

const Etc = () => {
  let { path } = useRouteMatch();

  return (
    <Suspense fallback={<CircularProgress />}>
      <Switch>
        <RoutePrivate exact path={`${path}/adminroles`} component={AdminRoles} permission='LIVE SERVICE' />
        <RoutePrivate exact path={`${path}/adminlogs`} component={AdminActionLogs} permission='LIVE SERVICE' />
        <RoutePrivate exact path={`${path}/testeraccount`} component={TesterAccount} permission='VIEWER' />

        <Route path='*'>
          <Redirect to={`/${config.game}/dashboard/notfound`} />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default Etc;
